export default "__VITE_ASSET__b7f0d1b0__"